import { render, staticRenderFns } from "./TraxTrainingRatingCrudForm.vue?vue&type=template&id=c3a07aba&scoped=true"
import script from "./TraxTrainingRatingCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRatingCrudForm.vue?vue&type=script&lang=js"
import style0 from "./TraxTrainingRatingCrudForm.vue?vue&type=style&index=0&id=c3a07aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a07aba",
  null
  
)

export default component.exports